import { render, staticRenderFns } from "./FundDialog.vue?vue&type=template&id=c0534008&scoped=true"
import script from "./FundDialog.vue?vue&type=script&lang=js"
export * from "./FundDialog.vue?vue&type=script&lang=js"
import style0 from "./FundDialog.vue?vue&type=style&index=0&id=c0534008&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0534008",
  null
  
)

export default component.exports